import io from "socket.io-client";
import { SOCKET_API_URL } from "./config";

const URL = SOCKET_API_URL;

export const socket = io(URL, {
  autoConnect: false,
  query: {},
});
